import React from "react"

export const DeleteSingleTypeRefinementItem = ({
  type_name,
  all_types,
  refine,
  currentRefinement,
  is_deleted,
}) => {
  const toogle_type = () => {
    const leftovers = is_deleted
      ? [...currentRefinement, type_name]
      : currentRefinement.filter((item) => item !== type_name)
    refine(!!leftovers[0] ? leftovers : all_types)
  }

  return (
    <div
      onClick={toogle_type}
      onKeyPress={() => {}}
      role="button"
      tabIndex="-1"
      aria-label="delete single type from refinement"
      className={`tag is-delete ${is_deleted ? "is-refined" : ""}`}
      style={{ borderLeft: is_deleted ? "1px solid #444" : "1px solid #DDD" }}
    ></div>
  )
}
